const getDateFromString = (date: string) => {
  if (!date) return null;

  // Expected date format: YYYY-MM-DD
  const [year, month, day] = date.split('-');
  return new Date(Number(year), Number(month) - 1, Number(day));
};

export default getDateFromString;
